import { render, staticRenderFns } from "./RemoveSchoolDialog.vue?vue&type=template&id=09cbbe03&scoped=true&"
import script from "./RemoveSchoolDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveSchoolDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSchoolDialog.vue?vue&type=style&index=0&id=09cbbe03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cbbe03",
  null
  
)

export default component.exports